import { atom } from 'recoil';
import { FilterDef } from '../../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "payments-tools-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'payments-tools-state-active-filters',
    default: []
});

